import { BREADCRUMBS_GET_REQUEST } from '../actionTypes/PDPBreadcrumbsActionTypes';

const getPDPBreadcrumbsAction = (ppId, enableV2Breadcrumb, query) => ({
    type: BREADCRUMBS_GET_REQUEST,
    ppId,
    enableV2Breadcrumb,
    query,
});

export default getPDPBreadcrumbsAction;
